"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { MainShopProduct } from "@/core/models/shop-product-model";
import { Heading } from "@/components/ui/Heading";
import { ChevronLeft, ChevronRight } from "lucide-react";
import ProductCard from "./ProductCard";
import { useId } from "react";
import Link from "next/link";
import { useDictionary } from "@/core/hooks/use-dictionary";
import { getSeeAllHref } from "@/core/lib/widget-params";
import CustomButton from "./CustomButton";
import FullWidth from "@/components/shared/FullWidth";

// settings از WidgetsRender (سرور) میاد، نه از هوک useSiteSettings سمت
// کلاینت — وگرنه قیمت محصولات (که به مالیات تنظیمات وابسته‌ست) تو اولین
// رندر بدون تنظیمات محاسبه می‌شد و با سایر جاهای سایت فرق می‌کرد.
export default function ProductBar({ data, isHome = false, settings }: { data: MainShopProduct; isHome?: boolean; settings?: any }) {
  const { dictionary } = useDictionary()

  const seeAllHref = getSeeAllHref(data);

  const uid = useId().replace(/:/g, "-");

  const prevClass = `swiper-prev-${uid}`;
  const nextClass = `swiper-next-${uid}`;

  const content = (
    <>
      <div className="flex justify-between items-center mb-4">
        <Heading level={2} className="pb-2">
          {data.title}
        </Heading>

        <div className="flex items-center gap-3">
          {/* مشاهده همه - لینکی که توی ادمین برای همین ویجت انتخاب شده */}
          {seeAllHref && (
            <>
              <Link href={seeAllHref} className="text-xs text-primary-600 hover:underline whitespace-nowrap">
                {dictionary.ui.pages.seeAll}
              </Link>

              {/* خط جداکننده */}
              <span className="w-px h-4 bg-primary-300" />
            </>
          )}

          {/* دکمه‌های ناوبری */}
          <div className="flex gap-2">
            <CustomButton className={`${prevClass} w-8 h-8 rounded-full border border-primary-900 bg-white flex items-center justify-center`}>
              <ChevronRight className="w-4.5 h-4.5 stroke-1" />
            </CustomButton>
            <CustomButton className={`${nextClass} w-8 h-8 rounded-full border border-primary-900 bg-white flex items-center justify-center`}>
              <ChevronLeft className="w-4.5 h-4.5 stroke-1" />
            </CustomButton>
          </div>
        </div>
      </div>

      <Swiper
        modules={[Navigation]}
        spaceBetween={16}
        slidesPerView="auto"
        pagination={{ clickable: true }}
        className="w-full"
        navigation={{
          nextEl: `.${nextClass}`,
          prevEl: `.${prevClass}`,
        }}
        effect="fade"
        fadeEffect={{
          crossFade: true
        }}
      >
        {data.items?.map((item) => (
          <SwiperSlide key={item.id} style={{ width: "300px" }}>
            <ProductCard product={item} settings={settings} />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );

  // isHome: چون صفحه‌ی اصلی برخلاف بقیه‌ی صفحات داخل یه Container محدود
  // رندر نمی‌شه، از FullWidth برای کشیدن بک‌گراند طوسی تا لبه‌ی واقعی صفحه
  // استفاده می‌کنیم و پدینگ هم‌تراز با بقیه‌ی ویجت‌ها رو داخلش برمی‌گردونیم.
  if (isHome) {
    return (
      <FullWidth className="col-span-12 bg-primary-50 py-4">
        <div className="px-4 sm:px-6 lg:px-12 xl:px-20">{content}</div>
      </FullWidth>
    );
  }

  return (
    <div className="w-full col-span-12 bg-primary-50 p-4">
      {content}
    </div>
  );
}